import { render, staticRenderFns } from "./SectionUserDataEmail.vue?vue&type=template&id=0c1f258e"
import script from "./SectionUserDataEmail.vue?vue&type=script&lang=ts"
export * from "./SectionUserDataEmail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports